import { get } from "lodash-es";
import bus from "vue3-eventbus";

import { checkIsMobile } from "@/utils/index";
import { openGoogleMap } from "@/utils/map";
import { initTheme } from "@/utils/theme";

import BookTipDialog from "../../views/hotel/Detail/components/itis/BookTipDialog.vue";
import { IChannelConfigs, IChannelTheme } from "../types";
import ITISBackToTop from "./components/Index/backToTop.vue";
import Promotion from "./components/Index/Promotion.vue";
import ITISFooter from "./components/Layout/Footer.vue";
const theme: IChannelTheme = {};

/** 点击rate预订时需要显示提示的酒店品牌 */
const SHOW_CUSTOM_DIALOG_BRAND_GROUP = [
  "617f99c32b7f08462afded45", // 安縵
  "61606b798dec39489e15193e" // dev 凯悦集团
];

export default {
  configs: {
    header: {
      logoAlign: "left"
    },
    currency: "TWD",
    givenNameFirst: true,
    useChannelLogo: true,
    logoUrl: "https://uploads.ytripos.com/FsP3SPw9sbo5IUeLbX2jJnD7yOfB_55.png",
    useChannelLanguages: true,
    showPrivateGender: false,
    components: {
      Footer: {
        component: ITISFooter, // 定制版 Footer
        props: {
          showCopyRight: false
        }
      },
      IndexBackToTop: {
        component: ITISBackToTop,
        props: {
          preventBtn: true
        }
      },
      IndexBeforeFeaturedHotels: {
        component: Promotion
      },
      BookTipDialog: {
        component: BookTipDialog
      }
    },
    pages: {
      Index: {
        logoUrl:
          "https://uploads.ytripos.com/FsP3SPw9sbo5IUeLbX2jJnD7yOfB_55.png",
        banners: {
          list: [
            {
              img: "https://uploads.ytripos.com/uploaded/lh6Z3QSSyQNO8JVnfO4tHK8U0_bK/itis-web.png"
            }
          ]
        },
        featuredHotels: [
          "5b35eb4021b146b104fd6142",
          "690812d063875f0dc0f02078",
          "5b506d246a8860a3024da691",
          "5da8b15a72c052077005ba77",
          "5b506a4d6a8860a3024d8947"
        ],
        specialPromotions: {
          titleI18n: {
            zh_TW: "活動推薦",
            en: "Recommend Activity"
          },
          promotions: [
            {
              subtitleI18n: {
                zh_TW: "滿額即贈「台灣機場接送」！讓旅程從踏出家門開始",
                en: "Spend & Get Free Taiwan Airport Transfers – Your Journey Begins the Moment You Leave Home"
              },
              descriptionI18n: {
                zh_TW: `數量有限！贈完為止！！\n單筆訂單滿 TWD 50,000 元以上，即贈台灣機場接送高級轎車 1 趟，折抵金 TWD 900 元\n單筆訂單滿 TWD 100,000 元以上，即贈台灣機場接送高級轎車 2 趟，折抵金共 TWD 1,800 元\n單筆訂單滿 TWD 150,000 元以上，即贈台灣機場接送豪華轎車 2 趟，折抵金共 TWD 2,400 元`,
                en: "Limited quantity!!\nFor a single booking reaching TWD 50,000 or above → Receive 1 premium sedan Taiwan airport transfer (value TWD 900)\nFor a single booking reaching TWD 100,000 or above → Receive 2 premium sedan Taiwan airport transfers (total value TWD 1,800)\nFor a single booking reaching TWD 150,000 or above → Receive 2 luxury sedan Taiwan airport transfers (total value TWD 2,400)"
              },
              buttonTextI18n: {
                zh_TW: "活動說明",
                en: "Promotion Details"
              },
              buttonLink: "https://www.itis.com.tw/limited_detail.php?id=69",
              backgroundImage:
                "https://uploads.ytripos.com/uploaded/FnVnArMMhe-Nc3pfAfD3yvq2qvBb/itis-airport-promotion.png"
            },
            {
              subtitleI18n: {
                zh_TW: "歡慶網站盛大揭幕，酒店贈禮等你來拿！",
                en: "Celebrating the grand unveiling of the website, hotel gifts await you!"
              },
              descriptionI18n: {
                zh_TW:
                  "為了給您更難忘的旅程體驗，我們與酒店攜手，為您的旅程帶來不一樣的禮遇。點擊下方「領取專屬禮遇」，即可查看合作酒店與專屬贈禮！",
                en: "To provide you with an unforgettable travel experience, we work closely with hotels to offer you a range of benefits. Click on 'Get Exclusive Benefits' below to view our partner hotels and the gifts they offer!"
              },
              buttonTextI18n: {
                zh_TW: "領取專屬禮遇",
                en: "Get Exclusive Benefits"
              },
              buttonLink: "https://www.itis.com.tw/limited.php",
              backgroundImage:
                "https://uploads.ytripos.com/uploaded/FkZVDcupEZ4uz4X2m-I0Wx55aZaz/ITIS_web_home_banner_0917.png"
            },
            {
              subtitleI18n: {
                zh_TW: "預訂即送！專屬網路折扣碼",
                en: "Book Now and Get an Exclusive Internet Discount Code!"
              },
              descriptionI18n: {
                zh_TW:
                  "出門旅行，網路不可少！立即在網站預訂，折扣碼將自動寄送到你手中，讓旅程從一開始就超值又順暢！",
                en: "Heading out on a trip? You can't go without the internet! Book directly on our website, and your discount code will be sent to you automatically, making your journey extra smooth and rewarding right from the start!"
              },
              buttonTextI18n: {
                zh_TW: "立即預訂",
                en: "Book Now"
              },
              buttonLink: "https://www.itis.com.tw/",
              backgroundImage:
                "https://uploads.ytripos.com/uploaded/Fn-Iq4TaaovqMQpuIGWGZ1eUJa5Q/%E4%BC%81%E4%B8%9A%E5%BE%AE%E4%BF%A1%E6%88%AA%E5%9B%BE_2a3b7186-f9c0-4ce6-b98d-c4f2ed63bd3e.png"
            }
          ]
        },
        rediscoverAsia: {
          loadHotels: false,
          hotelList: [
            {
              images: [
                "https://uploads.ytripos.com/uploaded/Fuz3V1guVVXwdBkfq2ULEK8cTcJ7/75645f4626fd4ffe02715eee08464ad0.png"
              ],
              nameI18n: {
                en: "Aman Bali",
                zh_TW: "安縵峇里島"
              },
              descriptionI18n: {
                en: "Spend 5 days and 4 nights at the timeless luxury retreats of Amandari and Amankila, where tranquility and elegance come together in the heart of Bali. Immerse yourself in the island’s rich culture and unique traditions, or embrace the freedom of nature—whether among the refreshing mountain breezes or along the endless ocean horizon. A journey designed to restore both body and mind.",
                zh_TW:
                  "於峇里島上 Amandari 及 Amankila 的傳統奢華民居內度過5天4夜的假期，享受心靈前所未有的寧靜。在此，您可以深入體驗當地文化，體驗峇里島獨特的風土人情；也可以踏入山間清風或是海上坦途，感受身心的全然自由。"
              },
              externalLink: "https://www.itis.com.tw/limited_detail.php?id=73"
            },
            {
              images: [
                "https://uploads.ytripos.com/uploaded/FlZbYGm7ODTQJplOKt-B6VC6UtM6/ede45a94c07cfc4d5d6954fcf7cae139.png"
              ],
              nameI18n: {
                en: "Bali Luxury Escape",
                zh_TW: "峇里島輕奢"
              },
              descriptionI18n: {
                en: "Experience the perfect blend of a private chauffeur service and independent exploration over five unforgettable days. Discover Bali's iconic cultural attractions, savor authentic local cuisine, and enjoy its most popular experiences—all in one trip! Stay at a stylish resort in Ubud and the prestigious AYANA Resort Bali, then end your days at the world-renowned Rock Bar, where you can admire breathtaking ocean sunsets in an unforgettable setting.",
                zh_TW:
                  "五日包車＋半自助玩法，經典文化景點、在地美食與人氣體驗一次收集！入住烏布質感渡假飯店與 AYANA 頂級海景度假村，再到全球知名 Rock Bar 欣賞夢幻海景日落！"
              },
              externalLink: "https://www.itis.com.tw/limited_detail.php?id=72"
            },
            {
              images: [
                "https://uploads.ytripos.com/uploaded/FuPyGJoQFGJ_yr4VyVDzdp5LX-Gj/31fd53bea97247cde55ee20f88352649.jpg"
              ],
              nameI18n: {
                en: "Orient Express",
                zh_TW: "東方快車"
              },
              descriptionI18n: {
                en: "One journey, three extraordinary experiences. The Orient Express brings together the iconic La Dolce Vita train, historic palace hotels, and the magnificent Corinthian yacht, taking you through Italy's stunning coastlines and inland treasures. Discover the country in the style of Europe's aristocracy, where timeless elegance, rich heritage, and exceptional craftsmanship come together.",
                zh_TW:
                  "一趟旅程，三種觸動。東方快車將經典的甜蜜生活號列車、底蘊深厚的宮殿酒店，以及當代工藝巔峰的科林斯號串連，帶您深入探索義大利沿岸及內陸，體驗過去歐洲貴族的旅行方式。"
              },
              externalLink: "https://www.itis.com.tw/limited_detail.php?id=68"
            },
            {
              images: [
                "https://uploads.ytripos.com/uploaded/FhdsI9LmJMr_W_nwGFoYeaNLdGoh/41d3c79316ecbfcbe7b26e74c7cbd5d2.jpg"
              ],
              nameI18n: {
                en: "Finland",
                zh_TW: "芬蘭"
              },
              descriptionI18n: {
                en: "This winter, discover the magic of Finland and experience the serenity of the Nordic snow-covered landscapes. Enjoy a privately tailored journey for two, featuring private transfers, handpicked hotels, and glass igloo stays where the Northern Lights may be your final view before sleep. Cross into Norway to catch and savor fresh king crab, meet Santa Claus at Santa Claus Village, and race through snowy forests on an unforgettable husky sled adventure.",
                zh_TW:
                  "今年冬季，邀您走入芬蘭，體驗北歐雪原的靜謐以及芬蘭經典遊程。\n兩人成行，私人訂製專屬行程，芬蘭你想要的全都有，全程包車並精選酒店及玻璃屋度假村，讓極光成為入睡前的最後一道風景。\n我們將跨越邊境前往挪威捕捉帝王蟹，品嚐新鮮現撈的極致鮮美；在聖誕老人村與聖誕老人合照，寄出旅程的回憶；在冰雪森林中，乘坐哈士奇雪橇感受雪原上的速度與激情。"
              },
              externalLink: "https://itis.com.tw/limited_detail.php?id=74"
            }
          ]
        }
      },
      prepareOrder: {
        showCancellationPopover: true
      },
      auth: {
        showInvitationCode: true
      }
    },
    footer: {
      show: true
    },
    seo: {
      title: "ITIS唯客樂旅行社 | 奢華旅遊訂房、訂製、客製化",
      description:
        "隨時開啟你的假期！一鍵訂房，快速又方便。專業旅遊顧問提供量身打造的客製化旅遊規劃，讓每一趟旅程都享有專屬的極致體驗！",
      keywords:
        "唯客樂旅行社,ITIS,itis,奢華旅遊,出國旅遊,台灣旅遊,訂製旅遊,客製化旅遊,自由行"
    }
  },
  init() {
    if (checkIsMobile()) {
      window.location.href = "https://itis-m.ytripos.com/";
      return;
    }
    initTheme(theme);
  },
  openLocation({ address }) {
    openGoogleMap({
      address
    });
  },
  beforeHotelBook({ hotel, rate }) {
    return new Promise((resolve, reject) => {
      const groupId = get(hotel, "brand.group._id");
      if (SHOW_CUSTOM_DIALOG_BRAND_GROUP.includes(groupId)) {
        bus.emit("showBookTipDialog", { rate });
        reject();
      } else {
        resolve(true);
      }
    });
  }
} as IChannelConfigs;
